import breadcrumb from '@app/locales/translates/breadcrumb';
import general from '@app/locales/translates/general';
import BrandCreateBrand from '@app/locales/translates/brand/createbrand';
import ProjectCreateProject from '@app/locales/translates/project/createproject';
import Group from '@app/locales/translates/project/projectSetting/group';
import AccountSignin from '@app/locales/translates/accounts/signin';
import AccountSchema from '@app/locales/translates/accounts/schema';
import AccountRegister from '@app/locales/translates/accounts/register';
import AccountOtp from '@app/locales/translates/accounts/otp';
import AccountTnC from '@app/locales/translates/accounts/tandc';
import AccountResetPassword from '@app/locales/translates/accounts/resetpassword';
import EndUser from '../translates/users/endUser';
import PermissionList from '@app/locales/translates/permission/listpermission';
import UserProfile from '@app/locales/translates/users/profile';
import Winnonie from '@app/locales/translates/winnonie';

const translateTh = {
  general: general.TH,
  menu: {
    project: 'โปรเจค',
    sign_out: 'Sign out',
    access: 'เข้าออก',
  },
  RealTimeLogPage: {
    title: 'ล็อคเกอร์',
  },
  locker: {
    dashboard: 'แดชบอร์ด',
    user_management: 'การจัดการผู้ใช้งาน',
    reservation_management: 'Reservation Management',
    reservation_management_locker: 'Locker',
    reservation_management_mailbox: 'Mailbox',
    locker_mailbox: 'Locker & Mailbox',
    locker: 'Locker',
    mailbox: 'mailbox',
    transaction_log: 'Transaction Log',
    notification: 'Notification',
    order: 'สั่งซื้อ',
  },
  breadcrumb: breadcrumb.TH,
  accounts: {
    signin: AccountSignin.TH,
    schema: AccountSchema.TH,
    register: AccountRegister.TH,
    otp: AccountOtp.TH,
    tandc: AccountTnC.TH,
    resetpassword: AccountResetPassword.TH,
  },
  brand: {
    createbrand: BrandCreateBrand.TH,
  },
  project: {
    createproject: ProjectCreateProject.TH,
    project_setting: {
      group: Group.TH,
    },
  },
  user: {
    endUser: EndUser.TH,
    profile: UserProfile.TH,
  },
  permission: {
    listpermission: PermissionList.TH,
  },
  winnonie: Winnonie.TH,
};

export default translateTh;
